import i18n from 'i18n';
import { ValueFormatterParams } from '@ag-grid-enterprise/all-modules';
import { USER_ACCOUNT_STATE } from 'users/user-enum';

export function userStateValue(value: string): string {
  switch (value) {
    case USER_ACCOUNT_STATE.Active:
      return i18n.t('user.accountState.active');

    case USER_ACCOUNT_STATE.Pending:
      return i18n.t('user.accountState.pending');

    case USER_ACCOUNT_STATE.PasswordRequired:
      return i18n.t('user.accountState.passwordChangeRequired');

    case USER_ACCOUNT_STATE.Deactivated:
      return i18n.t('user.accountState.deactivated');

    case USER_ACCOUNT_STATE.Locked:
      return i18n.t('user.accountState.locked');

    default:
      return i18n.t('user.accountState.unknown');
  }
}

export default function userStateValueFormatter({ value }: Partial<ValueFormatterParams>): string {
  return userStateValue(value);
}
